const site = site || {};
site.Forms = (() => {
    
    const dropzone = () => {
        // console.log('dropzone()');
    }
        
    const wysiwyg = () => {
        const wysiwygs = document.querySelectorAll('.js-wysiwyg');
        if (wysiwygs) {
            wysiwygs.forEach((wysiwyg, index) => {
                const editor = wysiwyg.querySelector('#quill-editor');
                // Set WYSIWYG HTML to match input value
                const input = wysiwyg.querySelector('.js-wysiwyg-input');
                const editorHtml = wysiwyg.querySelector('.ql-editor');
                editor.innerHTML = input.value;
                // Initialize WYSIWYG
                var quill = new Quill(editor, {
                    modules: {
                        toolbar: [
                            [{ header: [1, 2, false] }],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                            ['bold', 'italic', 'underline'],
                            ['link', 'image'],
                        ],
                    },
                    theme: 'snow',
                });
                // Update input when WYSIWYG is updated
                quill.on('text-change', (delta, oldDelta, source) => {
                    const html = quill.getSemanticHTML();
                    input.value = html;
                });
            })
        }
    }

    return {
        dropzone: dropzone,
        wysiwyg: wysiwyg,
    }
})();
